import React from 'react'
import { View, StyleSheet, Text } from 'react-native'
import { IconForbid } from '../../../../assets/icons'
import { ScreenWrapper } from '../components/ScreenWrapper'
import { useTranslation } from 'react-i18next'

interface ISyncInvoiceAgain {
  isWeb: boolean
}

export const SyncInvoiceAgain: React.FC<ISyncInvoiceAgain> = ({ isWeb }) => {
  const { t } = useTranslation('global')
  return (
    <ScreenWrapper isWeb={isWeb}>
      <View
        style={[
          styles.container,
          isWeb ? { marginTop: 60 } : { marginTop: 100, paddingHorizontal: 10 },
        ]}
        testID={'sync-invoice-again-container'}
      >
        <IconForbid />
        <View
          style={styles.textsContainer}
          testID={'sync-invoice-again-message'}
        >
          <Text
            style={styles.mainText}
            testID={'sync-invoice-again-main-title'}
          >
            {t('integrations.invoice-not-found')}
          </Text>
          <Text
            style={styles.infoText}
            testID={'sync-invoice-again-info-title'}
          >
            {t('integrations.ask-sync-invoice')}
          </Text>
        </View>
      </View>
    </ScreenWrapper>
  )
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 20,
  },
  textsContainer: {
    marginTop: 38,
  },
  mainText: {
    fontFamily: 'Inter',
    fontSize: 24,
    fontWeight: '700',
    lineHeight: 32,
    textAlign: 'center',
    color: '#19262F',
    maxWidth: 581,
  },
  infoText: {
    marginTop: 8,
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 32,
    textAlign: 'center',
    color: '#19262F',
  },
})
